module.exports = __webpack_public_path__ + "media/images/flags/64/Bosnia-and-Herzegovina-166f3e1fb05f2957dce124ca44f42d6c.png";